var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1230_1575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.05176e-05 11.9994C-3.05176e-05 13.4672 0.264016 14.8733 0.74636 16.1732L12 17.2167L23.2536 16.1732C23.7359 14.8733 24 13.4672 24 11.9994C24 10.5315 23.7359 9.12545 23.2536 7.82547L12 6.78198L0.74636 7.82547C0.264016 9.12545 -3.05176e-05 10.5315 -3.05176e-05 11.9994Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2551 7.82587C21.5596 3.2563 17.1611 -0.000244141 12.0015 -0.000244141C6.84192 -0.000244141 2.44341 3.2563 0.747894 7.82587H23.2551Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.746918 16.1741C2.44243 20.7436 6.84095 24.0002 12.0005 24.0002C17.1601 24.0002 21.5586 20.7436 23.2541 16.1741H0.746918Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1230_1575"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEs);
export default __webpack_public_path__ + "static/media/ES.c36de76f3a9bc9ba0eef68d5db18efe3.svg";
export { ForwardRef as ReactComponent };